import { Component,OnInit, ViewChild, HostListener } from '@angular/core';
import {Field} from "../../models/field.model";
import {DomSanitizer } from '@angular/platform-browser';
import {DetailService} from "../../../../services/details/detail.service";
import {HelperService} from "../../../../services/helperService";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import {BsModalService} from "ngx-bootstrap/modal";
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as ThumborUrlBuilder from "thumbor-url-builder";
import {AuthService} from "../../../../services";


@Component({
  selector: 'tig-form-campaignmanagement',
  templateUrl: './form-campaignmanagement.component.html',
  styleUrls: ['./form-campaignmanagement.component.scss']
})
export class FormCampaignmanagementComponent extends Field  implements OnInit{

	public static IFRAME_ID = 'iframe-campaignmanagement';

	@ViewChild('OBJ_model_iframe', {static:false}) OBJ_model_iframe;

	private OBJ_campaign: any;

	public isExportingIntern:boolean = false;
	public isExportingCustomer:boolean = false;
	private STR_route_menu: any;
	private STR_route_sub_menu: any;


	/**
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 * @param OBJ_detail_service
	 * @param OBJ_sanitizer
	 * @param OBJ_toastr_service
	 * @param OBJ_modal_service
	 * @param OBJ_helper_service
	 * @param OBJ_translate_service
	 * @param OBJ_route
	 * @param OBJ_router
	 * @param OBJ_auth_service
	 */
	constructor(
		private OBJ_spinner_service: Ng4LoadingSpinnerService,
		private OBJ_detail_service: DetailService,
		private OBJ_sanitizer: DomSanitizer,
		private OBJ_toastr_service: ToastrService,
		private OBJ_modal_service: BsModalService,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
		private OBJ_route: ActivatedRoute,
		private OBJ_router: Router,
		private OBJ_auth_service: AuthService
	)
	{
		super();
	} // end constructor

	private STR_id = "";

	private isSaving = false;

    ngOnInit(): void {
		this.STR_id = this.OBJ_route.snapshot.paramMap.get('id');

		this.OBJ_route.parent.params.subscribe(
			params =>
			{
				this.STR_route_menu = params["route_menu"];
			}
		);
		this.OBJ_route.params.subscribe(
			params =>
			{
				this.STR_route_sub_menu = params["route_submenu"];
			}
		)



    }

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormCampaignmanagementComponent.IFRAME_ID;
	} // end function getIFrameID

	/**
	 * Function > onMessage
	 * @desc Listen to messages from iframe
	 *
	 * @param event
	 */
	@HostListener('window:message', ['$event'])
	onMessage(event)
	{
		if(event.source.frameElement && event.source.frameElement.id === FormCampaignmanagementComponent.IFRAME_ID)
		{
			this.receiveMessageFromIFrame(event);
		}
	} // end function onMessage


	public saveCampaign()
	{

		let OBJ_msg =
			{
				"event": "save",
			};


		this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
	}

	public saveCampaignSuccess()
	{
		let OBJ_msg =
			{
				"event": "save_finish",
				"config": this.OBJ_campaign
			};
		this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
	}

	public saveCampaignFinish()
	{
		let OBJ_msg =
			{
				"event": "save_finish"
			};
		this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
	}

	public export(type:string)
	{

		let OBJ_msg =
			{
				"event": "export",
				"type":type
			};

		if(type === "intern")
		{
			this.isExportingIntern = true;
		}
		if(type === "customer")
		{
			this.isExportingCustomer = true;
		}

		this.OBJ_model_iframe.nativeElement.contentWindow.postMessage(OBJ_msg,"*")
	}




	private receiveMessageFromIFrame(event: any) {
		try
		{

			// try to parse the event we got
			let OBJ_data = event.data;

			switch (OBJ_data.event)
			{
				case 'ready':

					// post message to iFrame
					let OBJ_msg =
						{
							"event": "config",
							"id": this.STR_id,
							"campaign": this.OBJ_detail_service.OBJ_detail_content.data,
							"access_token": this.OBJ_helper_service.getFromLocalstorage('access').access_token,
							"refresh_token": this.OBJ_helper_service.getFromLocalstorage('access').refresh_token,
							"network":this.OBJ_helper_service.getFromLocalstorage('client').network,
							"readonly": this.OBJ_field_config.readonly
						};

					// Post data to iFrame
					event.source.postMessage(OBJ_msg, "*");

					break;

				case 'form_dirty':

					// post message to iFrame

					this.markAsDirtyAndTouched();

					break;

				case 'config':

					if(!this.isSaving)
					{
						// everything fine, set value
						this.OBJ_campaign = OBJ_data.data.campaign;

						this.save(this.OBJ_campaign);

					}

					break;

				case "export_success":

					if(OBJ_data.type =="intern")
					{
						this.isExportingIntern = false;
					}
					if(OBJ_data.type =="customer")
					{
						this.isExportingCustomer = false;
					}

					break;

				case 'imageupload':

					// upload image and send message to iframe
					let OBJ_form_data = new FormData();
					OBJ_form_data.append('upload', OBJ_data.data);
					OBJ_form_data.append('json', OBJ_data.json);
					this.OBJ_detail_service.post('/api/images', OBJ_form_data).subscribe(
						(OBJ_response: any) => {
							// TODO: Config-Daten wie crop und rotate werden aktuell noch ignoriert
							OBJ_response.event = "imageupload"
							OBJ_response.success = true;
							// Baue URL des Bildes zusammen
							let OBJ_thumbor_url_builder = new ThumborUrlBuilder("infinity", "https://thumbor.vogel.de");
							OBJ_response.url = OBJ_thumbor_url_builder.
							setImagePath(OBJ_response.server + OBJ_response.folderprefix +
								OBJ_response.folder +
								OBJ_response.filename +
								"." + OBJ_response.ext).
							buildUrl();
							event.source.postMessage(OBJ_response, event.origin);
							this.OBJ_helper_service.log({ class: "CampaignManagementComponent", function: "receiveMessageFromIFrame", uploadFile: OBJ_response});
						},
						(OBJ_error) => {
							event.source.postMessage({event:"imageupload",success: false}, event.origin);
							// output saving failed
							this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("oUpload.sFailed"));
						},
						() => {
							// output saving successfully
							this.OBJ_toastr_service.success(this.OBJ_translate_service.instant("oUpload.sSuccessfully"));
						});

					break;
				case 'config_invalid':

					// post message to iFrame

					this.OBJ_toastr_service.warning(this.OBJ_translate_service.instant("oError.sInvalidFields"));

					break;
				case 'generate_hash':
					let OBJ_hash = this.OBJ_helper_service.generateHash(OBJ_data.params, OBJ_data.body, this.OBJ_auth_service.getToken("access_token"));
					// Post data to iFrame
					event.source.postMessage(OBJ_hash, event.origin);
					break;

			} // end switch

		}
		catch (e) {
			// Not the event we are looking for, no need to take action
		} // end try/catch
	}

	/**
	 * Function > showError
	 *
	 * @desc Gebe Nutzer Feedback ueber Fehler
	 * @param OBJ_error
	 */
	showError(OBJ_error)
	{

		if (OBJ_error.status == 0)
		{
			// output error
			this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("error_default"));
		}
		else if (typeof OBJ_error.error.cst_type != "undefined")
		{
			// output error
			this.OBJ_toastr_service.error(this.OBJ_translate_service.instant(OBJ_error.error.cst_type.toLowerCase()));
		}
		else if (OBJ_error.error.error)
		{
			// output error
			this.OBJ_toastr_service.error(OBJ_error.error.error.message);
		}
		else
		{
			// output error
			this.OBJ_toastr_service.error(OBJ_error.error.detail);
		} // end if

	} // end function showError

	save(OBJ_campaign){

		this.isSaving = true;

		let  OBJ_result;
		if(this.STR_id == "new")
		{
			OBJ_campaign.network_id = [this.OBJ_helper_service.getFromLocalstorage('client').network];
			OBJ_result = this.OBJ_detail_service.post(
				this.OBJ_detail_service.OBJ_detail_content.getLinkToSelf(),
				OBJ_campaign
			)
		}
		else {
			OBJ_result = this.OBJ_detail_service.put(
				this.OBJ_detail_service.OBJ_detail_content.getLinkToSelf(),
				OBJ_campaign
			)
		}

		OBJ_result.subscribe((OBJ_response)=>{
				// console log
				this.OBJ_helper_service.log
				(
					{class: 'DetailComponent', function: 'save'},
					"Response after save:",
					OBJ_response
				);

				this.OBJ_toastr_service.success(this.OBJ_translate_service.instant("saved_successfully"));


				this.OBJ_campaign = OBJ_response;

				this.saveCampaignSuccess();

				this.STR_id = OBJ_campaign._id;

				this.OBJ_detail_service.clearForm();
				this.getFormControl().markAsUntouched();
				this.getFormControl().markAsPristine();

				this.OBJ_router.navigate([
					this.STR_route_menu,
					this.STR_route_sub_menu,
					OBJ_campaign._id
				]);

			},(OBJ_error)=>{
				this.OBJ_helper_service.log
				(
					{class: 'DetailComponent', function: 'update'},
					"Error",
					OBJ_error
				);
				this.showError(OBJ_error);

				this.saveCampaignFinish();
			},
			()=>{

				this.isSaving = false;
				// Ladeanimation aus

			});
	}

}
